// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "../components/stimulus_application"

import TinymceController from "./tinymce_controller"
import DatePickersController from "./date_pickers_controller"

application.register("tinymce", TinymceController)
application.register("date_pickers", DatePickersController)
